import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './WaitlistControls.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faAngleDown } from '@fortawesome/pro-regular-svg-icons';

import { getAvailableCountries } from '../../api/waitlist_blocked_countries';

const AUTOMATION_STATUS_OPTIONS = ['Needs Manual Review', 'Awaiting Automation', 'Automation Decided', 'All'];

const WaitlistControls = props => {
  const { curSearchValue, setCurSearchValue, automationStatus, setAutomationStatus, countryCode, setCountryCode } = props;
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    getAvailableCountries()
      .then(res => setCountries(res.countries || []))
      .catch(() => {});
  }, []);

  return (
    <div className='waitlist-controls-outer'>
      <div className='waitlist-controls-inner'>
        <div className='waitlist-controls-input-container'>
          <input
            type='text'
            className='waitlist-controls-input'
            placeholder='Search name, email, social media, pitch, or how they heard.'
            value={curSearchValue}
            onChange={e => setCurSearchValue(e.target.value)}
          />
          <FontAwesomeIcon icon={faTimes} className='waitlist-controls-input-icon' onClick={() => props.resetSearch()} />
        </div>

        <div className='waitlist-controls-input-container'>
          <div className='waitlist-controls-input-select-container'>
            <div className='waitlist-controls-input-icon'>
              <FontAwesomeIcon icon={faAngleDown} />
            </div>
            <select className='waitlist-controls-input' value={automationStatus} onChange={e => setAutomationStatus(e.target.value)}>
              {AUTOMATION_STATUS_OPTIONS.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className='waitlist-controls-input-container'>
          <div className='waitlist-controls-input-select-container'>
            <div className='waitlist-controls-input-icon'>
              <FontAwesomeIcon icon={faAngleDown} />
            </div>
            <select className='waitlist-controls-input' value={countryCode || ''} onChange={e => setCountryCode(e.target.value)}>
              <option value=''>All countries</option>
              {countries.map(c => (
                <option key={c.code} value={c.code}>{c.code} — {c.name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

WaitlistControls.propTypes = {
  automationStatus: PropTypes.string.isRequired,
  setAutomationStatus: PropTypes.func.isRequired,
  countryCode: PropTypes.string,
  setCountryCode: PropTypes.func.isRequired,
  curSearchValue: PropTypes.string.isRequired,
  setCurSearchValue: PropTypes.func.isRequired,
  resetSearch: PropTypes.func.isRequired
};

export default WaitlistControls;
